import { openDB } from 'idb'

export const useCachDate = async () => {
  const date = ref(null)

  if (import.meta.client) {
    const db = await openDB('desitincache', 1)
    await db
      .get('dateisincach', 'date')
      .then((value) => {
        date.value = value.currentDate
      })
      .catch((err) => {
        console.error('error getting date from indexdb')
      })
  }

  return date
}
